function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3893dbf2614d595b$exports = {};


var $34f5c0a6126ffa94$exports = {};
var $44b6c6f397b83d17$exports = {};

$parcel$export($44b6c6f397b83d17$exports, "CACHE_KEY_HEADER", () => $44b6c6f397b83d17$export$c87bb677964bca76);
$parcel$export($44b6c6f397b83d17$exports, "CACHE_TTL_HEADER", () => $44b6c6f397b83d17$export$f3cabd61c1a69cff);
$parcel$export($44b6c6f397b83d17$exports, "CACHE_TAGS_HEADER", () => $44b6c6f397b83d17$export$7a72ba053ce0e670);
const $44b6c6f397b83d17$export$c87bb677964bca76 = "x-fabric-cache-key";
const $44b6c6f397b83d17$export$f3cabd61c1a69cff = "x-fabric-cache-ttl";
const $44b6c6f397b83d17$export$7a72ba053ce0e670 = "x-fabric-cache-tags";


$parcel$exportWildcard($34f5c0a6126ffa94$exports, $44b6c6f397b83d17$exports);


var $a17398a5f5f400d3$exports = {};
var $5d9b3ec726ff6af2$exports = {};

$parcel$export($5d9b3ec726ff6af2$exports, "colors", () => $5d9b3ec726ff6af2$export$8f45430ccf837300);
const $5d9b3ec726ff6af2$export$8f45430ccf837300 = {
    grey: {
        0: "#EFF2F4",
        5: "#E5EAED",
        20: "#D3D8E1",
        35: "#AAB3BF",
        50: "#798291",
        70: "#444E5D",
        80: "#242C38",
        90: "#1A212C"
    },
    purple: {
        0: "#DAD2FF",
        60: "#4C00C2",
        80: "#3C0098",
        90: "#32007E",
        100: "#130031"
    },
    teal: {
        10: "#BDFAF9",
        50: "#0CD0CD",
        60: "#00B9B6"
    },
    green: {
        10: "#C8FFDD",
        30: "#19AC51",
        50: "#0E7936"
    },
    blue: {
        10: "#D7EAFF",
        50: "#3994FF",
        60: "#2781EA"
    },
    red: {
        10: "#FFC8CD",
        30: "#FC484C",
        40: "#DD3337",
        50: "#B71E21"
    },
    yellow: {
        10: "#FFE9AB",
        30: "#FFCA30",
        50: "#A95201"
    },
    "sticky-yellow": {
        100: "#FFE600"
    },
    "title-yellow": {
        100: "#FFC800"
    },
    orange: {
        30: "#FF8A00"
    },
    salmon: {
        30: "#FF808C"
    },
    white: "#FFFFFF",
    black: "#000000"
};


var $b865962558fecb78$exports = {};

$parcel$export($b865962558fecb78$exports, "screens", () => $b865962558fecb78$export$7a7a8c2474f854cd);
const $b865962558fecb78$export$7a7a8c2474f854cd = {
    phablet: "375px",
    tablet: "768px",
    desktop: "1024px",
    "desktop-l": "1440px",
    "desktop-xl": "1920px"
};


var $fdece3609c78438e$exports = {};

$parcel$export($fdece3609c78438e$exports, "spacing", () => $fdece3609c78438e$export$5458b64234d1333c);
const $fdece3609c78438e$export$5458b64234d1333c = {
    "3xs": "4px",
    "2xs": "8px",
    xs: "12px",
    sm: "16px",
    md: "24px",
    lg: "32px",
    xl: "40px",
    "2xl": "48px",
    "3xl": "56px"
};


var $0a5b9dea030afb9e$exports = {};

$parcel$export($0a5b9dea030afb9e$exports, "fontSize", () => $0a5b9dea030afb9e$export$85e3c3ca0c6fb93);
var $972f89d97dd11b9a$exports = {};

$parcel$export($972f89d97dd11b9a$exports, "fontWeight", () => $972f89d97dd11b9a$export$bc0b29e67df3229e);
const $972f89d97dd11b9a$export$bc0b29e67df3229e = {
    thin: "100",
    extralight: "200",
    light: "300",
    book: "400",
    normal: "450",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900"
};


const $0a5b9dea030afb9e$export$85e3c3ca0c6fb93 = {
    /* Body */ ["overline"]: [
        "10px",
        {
            lineHeight: "10px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["2xs"]: [
        "10px",
        {
            lineHeight: "12px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).book
        }
    ],
    ["2xs-bold"]: [
        "10px",
        {
            lineHeight: "12px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["xs"]: [
        "12px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).book
        }
    ],
    ["xs-bold"]: [
        "12px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["sm"]: [
        "14px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).book
        }
    ],
    ["sm-bold"]: [
        "14px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["base"]: [
        "16px",
        {
            lineHeight: "24px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).book
        }
    ],
    ["base-bold"]: [
        "16px",
        {
            lineHeight: "24px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["lg"]: [
        "20px",
        {
            lineHeight: "28px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).book
        }
    ],
    ["lg-bold"]: [
        "20px",
        {
            lineHeight: "28px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    /* Headings */ ["h-sm"]: [
        "16px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["h"]: [
        "20px",
        {
            lineHeight: "24px",
            letterSpacing: "-0.5px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["h-lg"]: [
        "25px",
        {
            lineHeight: "28px",
            letterSpacing: "-0.5px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["h-xl"]: [
        "31px",
        {
            lineHeight: "36px",
            letterSpacing: "-1px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["h-2xl"]: [
        "39px",
        {
            lineHeight: "44px",
            letterSpacing: "-1px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["h-3xl"]: [
        "48px",
        {
            lineHeight: "56px",
            letterSpacing: "-2px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    /* Buttons */ ["btn-sm"]: [
        "14px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["btn"]: [
        "16px",
        {
            lineHeight: "20px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ],
    ["btn-lg"]: [
        "20px",
        {
            lineHeight: "24px",
            fontWeight: (0, $972f89d97dd11b9a$export$bc0b29e67df3229e).bold
        }
    ]
};



var $7bbf1b2d4fb75ba6$exports = {};

$parcel$export($7bbf1b2d4fb75ba6$exports, "boxShadow", () => $7bbf1b2d4fb75ba6$export$16e1fc8de5cd9687);
const $7bbf1b2d4fb75ba6$export$16e1fc8de5cd9687 = {
    "1": "0px 2px 3px rgba(19, 0, 49, 0.1)",
    "2": "0px 4px 4px rgba(19, 0, 49, 0.2)",
    "3": "0px 4px 4px rgba(0, 0, 0, 0.25)"
};


var $9e704284198d2693$exports = {};

$parcel$export($9e704284198d2693$exports, "zIndex", () => $9e704284198d2693$export$56446adcecbeec34);
const $9e704284198d2693$export$56446adcecbeec34 = {
    basic: "0",
    overlay: "10",
    toast: "20",
    modal: "30",
    "modal-2": "40",
    "modal-3": "50"
};


$parcel$exportWildcard($a17398a5f5f400d3$exports, $5d9b3ec726ff6af2$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $b865962558fecb78$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $fdece3609c78438e$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $0a5b9dea030afb9e$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $972f89d97dd11b9a$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $7bbf1b2d4fb75ba6$exports);
$parcel$exportWildcard($a17398a5f5f400d3$exports, $9e704284198d2693$exports);


var $b622073b224b9e63$exports = {};

$parcel$export($b622073b224b9e63$exports, "createTracedFetch", () => $7cbae33e0941ce32$export$6f045624499c3b8b);
$parcel$export($b622073b224b9e63$exports, "createAuthenticatedFetch", () => $8fb9b00553d32e70$export$3916daabb4626637);
// https://istio.io/latest/about/faq/distributed-tracing/#how-to-support-tracing
// https://github.com/open-telemetry/opentelemetry-specification/blob/main/specification/trace/api.md#spancontext
// https://opentelemetry.io/docs/concepts/signals/traces/#context-propagation
// https://www.w3.org/TR/trace-context/#traceparent-header
// https://www.w3.org/TR/trace-context/#tracestate-header
const $d8c2aa934bc981a1$export$d62381197d366f3d = (headers, fetch, input, init)=>{
    if (init) {
        init.headers = {
            ...init.headers,
            ...headers
        };
        return fetch(input, init);
    } else if (typeof input == "string" || input instanceof URL) return fetch(input, {
        headers: {
            ...headers
        }
    });
    else if (input instanceof Request) {
        for (const [key, value] of Object.entries(headers))input.headers.append(key, value);
        return fetch(input);
    } else throw Error(`Don't know how to handle input: ${input}, init: ${init}`);
};


const $7cbae33e0941ce32$var$TRACE_PARENT = "traceparent";
const $7cbae33e0941ce32$var$TRACE_STATE = "tracestate";
const $7cbae33e0941ce32$var$TRACE_ORIGIN = "origin";
const $7cbae33e0941ce32$export$6f045624499c3b8b = (fetch, traceOrigin = "no-origin")=>{
    return (input, init)=>{
        const version = "00" // as hex
        ;
        const traceId = $7cbae33e0941ce32$var$randomHex(16);
        const parentId = $7cbae33e0941ce32$var$randomHex(8);
        const flags = "00" // unsampled - as hex
        ;
        const traceparent = `${version}-${traceId}-${parentId}-${flags}`;
        const traceState = new $7cbae33e0941ce32$var$TraceState();
        traceState.set($7cbae33e0941ce32$var$TRACE_ORIGIN, traceOrigin);
        return (0, $d8c2aa934bc981a1$export$d62381197d366f3d)({
            [$7cbae33e0941ce32$var$TRACE_PARENT]: traceparent,
            [$7cbae33e0941ce32$var$TRACE_STATE]: traceState.serialize()
        }, fetch, input, init);
    };
};
class $7cbae33e0941ce32$var$TraceState extends Map {
    constructor(...args){
        super(...args);
        this.serialize = ()=>{
            const buffer = [];
            this.forEach((value, key)=>buffer.push(`${key}=${value}`));
            return buffer.join(";");
        };
    }
}
const $7cbae33e0941ce32$var$randomHex = (length)=>{
    const toHex = (buffer)=>Array.from(buffer).map((b)=>b.toString(16).padStart(2, "0")).join("");
    return toHex(crypto.getRandomValues(new Uint8Array(length)));
};



const $8fb9b00553d32e70$var$AUTHORIZATION = "authorization";
const $8fb9b00553d32e70$var$X_PLAYER_MARKET = "x-player-market";
const $8fb9b00553d32e70$export$3916daabb4626637 = (fetch, accessTokenProvider, marketCodeProvider, responseInterceptor, maxRetries = 1)=>{
    return async (input, init)=>{
        if (!await accessTokenProvider()) return (0, $d8c2aa934bc981a1$export$d62381197d366f3d)({
            [$8fb9b00553d32e70$var$X_PLAYER_MARKET]: await marketCodeProvider()
        }, fetch, input, init);
        let retries = 0;
        let response;
        do {
            response = await (0, $d8c2aa934bc981a1$export$d62381197d366f3d)({
                [$8fb9b00553d32e70$var$AUTHORIZATION]: `Bearer ${await accessTokenProvider()}`
            }, fetch, input, init);
            if (response.status == 401) {
                await $8fb9b00553d32e70$var$sleep(1000);
                continue;
            }
            break;
        }while (retries++ < maxRetries);
        if (responseInterceptor) await responseInterceptor(response);
        return response;
    };
};
const $8fb9b00553d32e70$var$sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));




var $4e1d2e700da2c259$exports = {};
var $09b460e3f02c7208$exports = {};

$parcel$export($09b460e3f02c7208$exports, "truncateToDecimalPlaces", () => $09b460e3f02c7208$export$cef21d40e1b02b76);
$parcel$export($09b460e3f02c7208$exports, "formatCurrency", () => $09b460e3f02c7208$export$3dc27271f5d5c629);
const $09b460e3f02c7208$var$DEFAULT_NUMBER_FORMAT_OPTIONS = {
    style: "currency",
    currencyDisplay: "narrowSymbol"
};
const $09b460e3f02c7208$export$cef21d40e1b02b76 = (value, dp = 0)=>{
    if (typeof value !== "number") return value;
    const operator = value >= 0 ? 1 : -1;
    const positiveValue = operator * value;
    const regex = new RegExp(`^\\d+(?:\\.\\d{0,${dp}})?`);
    return operator * Number(positiveValue.toString().match(regex));
};
// For Norway we want to display "123 kr" instead of "kr 123"
// And that format is conveniently the same as Sweden so... Thanks Sweden!
const $09b460e3f02c7208$var$getNorwegianFormatterOverride = ()=>{
    return new Intl.NumberFormat("sv-SE", {
        ...$09b460e3f02c7208$var$DEFAULT_NUMBER_FORMAT_OPTIONS,
        currency: "SEK"
    });
};
const $09b460e3f02c7208$var$isNorwegianCurrency = (localeCode, iso4217CurrencyCode)=>localeCode === "no-NO" && iso4217CurrencyCode === "NOK";
const $09b460e3f02c7208$var$getIntlFormatter = ({ localeCode: localeCode , iso4217CurrencyCode: iso4217CurrencyCode  })=>{
    if ($09b460e3f02c7208$var$isNorwegianCurrency(localeCode, iso4217CurrencyCode)) return $09b460e3f02c7208$var$getNorwegianFormatterOverride();
    return new Intl.NumberFormat(localeCode, {
        ...$09b460e3f02c7208$var$DEFAULT_NUMBER_FORMAT_OPTIONS,
        currency: iso4217CurrencyCode
    });
};
const $09b460e3f02c7208$export$3dc27271f5d5c629 = ({ iso4217CurrencyCode: iso4217CurrencyCode , amount: amount , localeCode: localeCode  })=>{
    const formatter = $09b460e3f02c7208$var$getIntlFormatter({
        iso4217CurrencyCode: iso4217CurrencyCode,
        localeCode: localeCode
    });
    // Needed to keep trailing currency symbols and markets that don't use standard decimal places
    const findTrailingZerosRegex = /\D00(?=\D*$)/;
    return formatter.format($09b460e3f02c7208$export$cef21d40e1b02b76(amount, 2)).replace(findTrailingZerosRegex, "");
};


$parcel$exportWildcard($4e1d2e700da2c259$exports, $09b460e3f02c7208$exports);


var $1870cb79fda2ed46$exports = {};
var $8301272a7107c682$exports = {};

$parcel$export($8301272a7107c682$exports, "marketSlugToMarketCode", () => $8301272a7107c682$export$7073566980e67cea);
/**
 * Avoid using this, currently is being used by legacy fetch in fabric-spine-v2
 * Maps a *market slug* to a *market code*.
 *
 * This can be useful when communicating with Casumo backend api's when only the market slug is known.
 *
 * For *market slug* @see {@link https://github.com/Casumo/fabric-directus/blob/master/packages/directus-api/src/spine/types.ts#L56}
 * and for *market code* @see {@link https://github.com/Casumo/market-service/blob/master/src/main/java/com/casumo/market/domain/Market.java#L38}
 *
 * @param marketSlug - The market slug to map to a market code
 * @throws Will throw an error if the market slug can't be mapped
 */ const $8301272a7107c682$export$7073566980e67cea = (marketSlug)=>{
    switch(marketSlug){
        case "sv":
            return "se_sv";
        case "en-gb":
            return "gb_en";
        case "en":
            return "___en";
        default:
            throw Error(`Don't know how to map market slug: ${marketSlug}`);
    }
};


var $6e1b16b32b79471d$exports = {};

$parcel$export($6e1b16b32b79471d$exports, "urlPrefixToMarketMapper", () => $6e1b16b32b79471d$export$60117af52bf4002b);
const $6e1b16b32b79471d$var$URL_PREFIX_TO_MARKET_MAP = Object.freeze({
    en: "___en",
    "en-gb": "gb_en",
    "en-ca": "ca_en",
    "en-nz": "nz_en",
    "en-in": "in_en",
    es: "es_es",
    on: "on_en",
    fi: "fi_fi",
    sv: "se_sv",
    ie: "ie_en",
    no: "no_no",
    rog: "___en",
    row: "___en"
});
const $6e1b16b32b79471d$export$60117af52bf4002b = (marketPrefix)=>{
    return $6e1b16b32b79471d$var$URL_PREFIX_TO_MARKET_MAP[marketPrefix];
};


$parcel$exportWildcard($1870cb79fda2ed46$exports, $8301272a7107c682$exports);
$parcel$exportWildcard($1870cb79fda2ed46$exports, $6e1b16b32b79471d$exports);


var $3df5fd866c1c7308$exports = {};
var $7d7cb038be890bd9$exports = {};

$parcel$export($7d7cb038be890bd9$exports, "LANGUAGE_LOCALE_SEPARATOR", () => $7d7cb038be890bd9$export$45a2686166a4a2ae);
$parcel$export($7d7cb038be890bd9$exports, "isCurrentLocaleInFallback", () => $7d7cb038be890bd9$export$4df06cd8ad76e7e);
$parcel$export($7d7cb038be890bd9$exports, "shouldCombineLocalesFn", () => $7d7cb038be890bd9$export$2d1a0e3605839d5d);
$parcel$export($7d7cb038be890bd9$exports, "createTranslationsParams", () => $7d7cb038be890bd9$export$1a14d3b940023e7a);
$parcel$export($7d7cb038be890bd9$exports, "pickTranslation", () => $7d7cb038be890bd9$export$1e688c2249dcca2a);
const $7d7cb038be890bd9$export$45a2686166a4a2ae = "-";
const $7d7cb038be890bd9$export$4df06cd8ad76e7e = (currentLocaleCode, fallbackLocaleCode)=>fallbackLocaleCode && currentLocaleCode && currentLocaleCode.split($7d7cb038be890bd9$export$45a2686166a4a2ae)[0] === fallbackLocaleCode;
const $7d7cb038be890bd9$export$2d1a0e3605839d5d = (currentLocaleCode, fallbackLocaleCode)=>fallbackLocaleCode && currentLocaleCode !== fallbackLocaleCode && $7d7cb038be890bd9$export$4df06cd8ad76e7e(currentLocaleCode, fallbackLocaleCode);
const $7d7cb038be890bd9$export$1a14d3b940023e7a = (currentLocaleCode, fallbackLocaleCode)=>{
    const shouldCombineLocales = $7d7cb038be890bd9$export$2d1a0e3605839d5d(currentLocaleCode, fallbackLocaleCode);
    if (shouldCombineLocales) return {
        sort: "-languages_code",
        filter: {
            languages_code: {
                _in: [
                    fallbackLocaleCode,
                    currentLocaleCode
                ]
            }
        }
    };
    else return {
        filter: {
            languages_code: {
                _eq: currentLocaleCode
            }
        }
    };
};
const $7d7cb038be890bd9$export$1e688c2249dcca2a = (translations)=>translations[0] // We always pick the first translation in the array of translations because they are sorted from "more specific" (e.g "en-GB") to less specific (e.g "en")
;


var $c5bae7e626b55709$exports = {};

$parcel$export($c5bae7e626b55709$exports, "isMobile", () => $c5bae7e626b55709$export$d0a8044dce8ff2fc);
$parcel$export($c5bae7e626b55709$exports, "decorateImportWithRetries", () => $c5bae7e626b55709$export$1b907b697cb53059);
const $c5bae7e626b55709$export$d0a8044dce8ff2fc = ()=>{
    if (!window || typeof window === "undefined" || !window.navigator || !window.navigator.userAgent) return false;
    return /\b(?:BlackBerry|webOS|iPhone|IEMobile|Android|Windows Phone|iPad|iPod)\b/i.test(window.navigator.userAgent);
};
const $c5bae7e626b55709$export$1b907b697cb53059 = (importer)=>async ()=>{
        try {
            return await importer();
        } catch (error) {
            // retry 5 times with 2 second delay and backoff factor of 2 (2, 4, 8, 16, 32 seconds).
            for(let i = 0; i < 5; i++){
                await new Promise((resolve)=>setTimeout(resolve, 1000 * 2 ** i));
                try {
                    // Parcel JS fetches the chunk with timestamp appended, no need to manually add it here.
                    return await importer();
                } catch (e) {
                    console.warn("retrying import", e);
                }
            }
            // Re-throw original exception if retries failed.
            // We might want to catch it later and possibly reload the webapp
            // to have correct mapping of JS chunks.
            throw error;
        }
    };


$parcel$exportWildcard($3df5fd866c1c7308$exports, $7d7cb038be890bd9$exports);
$parcel$exportWildcard($3df5fd866c1c7308$exports, $c5bae7e626b55709$exports);




export {$44b6c6f397b83d17$export$c87bb677964bca76 as CACHE_KEY_HEADER, $44b6c6f397b83d17$export$f3cabd61c1a69cff as CACHE_TTL_HEADER, $44b6c6f397b83d17$export$7a72ba053ce0e670 as CACHE_TAGS_HEADER, $5d9b3ec726ff6af2$export$8f45430ccf837300 as colors, $b865962558fecb78$export$7a7a8c2474f854cd as screens, $fdece3609c78438e$export$5458b64234d1333c as spacing, $0a5b9dea030afb9e$export$85e3c3ca0c6fb93 as fontSize, $972f89d97dd11b9a$export$bc0b29e67df3229e as fontWeight, $7bbf1b2d4fb75ba6$export$16e1fc8de5cd9687 as boxShadow, $9e704284198d2693$export$56446adcecbeec34 as zIndex, $7cbae33e0941ce32$export$6f045624499c3b8b as createTracedFetch, $8fb9b00553d32e70$export$3916daabb4626637 as createAuthenticatedFetch, $09b460e3f02c7208$export$cef21d40e1b02b76 as truncateToDecimalPlaces, $09b460e3f02c7208$export$3dc27271f5d5c629 as formatCurrency, $8301272a7107c682$export$7073566980e67cea as marketSlugToMarketCode, $6e1b16b32b79471d$export$60117af52bf4002b as urlPrefixToMarketMapper, $7d7cb038be890bd9$export$45a2686166a4a2ae as LANGUAGE_LOCALE_SEPARATOR, $7d7cb038be890bd9$export$4df06cd8ad76e7e as isCurrentLocaleInFallback, $7d7cb038be890bd9$export$2d1a0e3605839d5d as shouldCombineLocalesFn, $7d7cb038be890bd9$export$1a14d3b940023e7a as createTranslationsParams, $7d7cb038be890bd9$export$1e688c2249dcca2a as pickTranslation, $c5bae7e626b55709$export$d0a8044dce8ff2fc as isMobile, $c5bae7e626b55709$export$1b907b697cb53059 as decorateImportWithRetries};
//# sourceMappingURL=module.mjs.map
